export var IdUrls;
(function (IdUrls) {
    IdUrls["companyUrl"] = "https://goodgamestudios.com";
    IdUrls["termsUrl"] = "https://www.goodgamestudios.com/terms_{lang}/#terms";
    IdUrls["privacyUrl"] = "https://www.goodgamestudios.com/terms_{lang}/#privacy";
    IdUrls["withdrawalUrl"] = "https://www.goodgamestudios.com/terms_{lang}/#withdrawal";
    IdUrls["supportUrl"] = "https://support.goodgamestudios.com/";
})(IdUrls || (IdUrls = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdUrls.ts
// module id = 941
// module chunks = 3